export default __webpack_public_path__ + "static/media/background.ab9e6c27.png";